import { Component,Inject,OnInit,PLATFORM_ID,Renderer2,TemplateRef,ViewChild} from '@angular/core';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { FormGroup } from '@angular/forms';
import { FormBuilder,Validators } from '@angular/forms';
import { MainserviceService } from 'src/app/mainservice.service';
import Swal from 'sweetalert2';
import { DatePipe, isPlatformBrowser } from '@angular/common';
import { MatDatepicker } from '@angular/material/datepicker';
import { Title, Meta } from '@angular/platform-browser';
import { Router } from '@angular/router';
import * as ngxSeo from 'ngx-seo';
@Component({
  selector: 'app-hosbay',
  templateUrl: './hosbay.component.html',
  styleUrls: ['./hosbay.component.scss'],
   providers:[MainserviceService,DatePipe]
})
export class HosbayComponent {
   enquiryForm:FormGroup;
    totalcountry:any=[];
    captcha:any
    errorcaptcha:any
    ecaptcha:boolean=false;
    dialcode:any;
    showElement: boolean = false;
    showElementsave: boolean = false;
    @ViewChild('picker') picker!: MatDatepicker<Date>;
    @ViewChild('inputField') inputField!: any;
    currentTime: Date;
    timeSlots:any=[];
    timezone:any;
    appointment_time:boolean=false;
    selectedTime: string | null = null;
    leads:any;
  constructor(private ngxsmartservice:NgxSmartModalService,private fb:FormBuilder,private router:Router,private seoService: ngxSeo.SeoSocialShareService,
    private mainservice:MainserviceService,private datePipe: DatePipe,private title:Title,private meta:Meta,private jsonLdService: ngxSeo.JsonLdService,private renderer: Renderer2,@Inject(PLATFORM_ID) private platformId: Object){

      this.setSeoMeta();
      if (isPlatformBrowser(this.platformId)) {

        this.setSchemaData();
      this.setFaqSchemaData();
      // this.title.setTitle("Transform Your Pharmacy with Medeil Software | Free Download");

      // Add meta tags dynamically
      // this.meta.addTag({ name: 'description', content: 'Discover how Medeil can revolutionize your pharmacy operations. Download now! Start freely access our best pharmacy software' });
      // this.meta.addTag({ name: 'keywords', content: 'Medeil, Pharmacy Management System, Pharmacy Billing Software, Medical Shop Software, Pharmacy Inventory Software' });
    this.timezone=sessionStorage.getItem('timezone');
    this.enquiryForm=this.fb.group({
        leadname: ['',[ Validators.required]],
        organizationname: ['',[Validators.required]],
        leadsourceid: ['',[]],
        leadsource: ['medeil website',[]],
        sourceRef1: ['',[]],
        sourceRef2: ['',[]],
        description: ['',[ Validators.required]],
        primaryphone: ['',[Validators.required]],
        primaryemail: ['',[Validators.required, Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$')]],
        address1: ['',[]],
        address2: ['',[]],
        country: [sessionStorage.getItem('country'),[],[]],
        countryname1: ['0',[]],
        state: [sessionStorage.getItem('state'),[]],
        city: [sessionStorage.getItem('city'),[]],
        enteredcaptcha: ['',[]],
        generatedcaptcha: ['',[]],
        phonedialcode:['',[]],
        checkbox:[false,[]],
        appfrmtime:['',[]],
        apptotime:['',[]],
        appointmentdate:['',[]],
      })
    }
    }
    selectedclass: number = 1;
    ngOnInit(): void {
      if (isPlatformBrowser(this.platformId)) {
      // this.navigateToHomeWithQueryParams();
      this.mainservice.generatecaptcha();
      this.captcha = localStorage.getItem('captcha')
       // ----country list--
       this.mainservice.getCountryList().subscribe(data=>{
         console.log(data);
         this.totalcountry=data;
       })
      }
    }

    setSeoMeta() {
      const supportedLanguages = ['en', 'fr', 'es', 'pt'];
      let finalUrl = '';
      let lang = 'en';

      if (isPlatformBrowser(this.platformId)) {
        const origin = window.location.origin;
        const path = window.location.pathname;
        const parts = path.split('/');

        if (supportedLanguages.includes(parts[1])) {
          lang = parts[1];
        }


        const fullPath = path.replace(/^\/[a-z]{2}/, '').replace(/\/+$/, ''); // remove trailing slash
        finalUrl = `${origin}/${lang}${fullPath ? '/' + fullPath : ''}`;

      }

      const seoData = {
        title: $localize`:@@HOSBAY.SEO_TITLE_HOSBAY:Hosbay: Advanced Hospital Inventory Management Software`,
        description: $localize`:@@HOSBAY.SEO_DESCRIPTION_HOSBAY:Boost hospital efficiency with Hosbay — smart inventory software to streamline supply, cut waste, and support better patient care.`,
        image: 'https://www.medeil.com/assets/hosbay.jpg',
        url: finalUrl,
        keywords: $localize`:@@HOSBAY.SEO_KEYWORDS_HOSBAY:Hospital inventory management, Healthcare supply chain, Inventory tracking software, Hosbay software, Medical inventory control, Healthcare efficiency, Patient care optimization, Stock management, best Hosbay software, hospital management software, patient management software, healthcare platform, hospital management software, digital health, clinic software, patient records, healthcare technology, HOSBAY, medical software, e-health`
      };

      this.title.setTitle(seoData.title);

      const metaTags = [
        { name: 'description', content: seoData.description },
        { name: 'keywords', content: seoData.keywords },
        { property: 'og:title', content: seoData.title },
        { property: 'og:description', content: seoData.description },
        { property: 'og:url', content: seoData.url },
        { property: 'og:type', content: 'website' },
        { property: 'og:image', content: seoData.image }
      ];

      metaTags.forEach(tag => this.meta.updateTag(tag));
    }


    setWebsiteSchema() {
      const schemaData = {
        "@context": "https://schema.org",
        "@type": "WebSite",
        "name": $localize`:@@HOSBAY.SCHEMA_NAME_HOSBAY:Hosbay`,
        "url": "https://www.medeil.com",
        "description": $localize`:@@HOSBAY.SCHEMA_DESCRIPTION_HOSBAY:Discover Hosbay, the state-of-the-art hospital inventory management software designed to enhance efficiency and accuracy in healthcare operations. Streamline your supply chain, reduce waste, and improve patient care with our comprehensive solution.`,
        "image": "https://www.medeil.com/assets/img/logo/medeil_logo_1.png",
        "publisher": {
          "@type": "Organization",
          "name": "Medeil",
          "url": "https://www.medeil.com",
          "logo": {
            "@type": "ImageObject",
            "url": "https://www.medeil.com/assets/img/logo/medeil_logo_1.png"
          }
        }
      };

      this.jsonLdService.setData(schemaData);
    }

    setSchemaData() {
      const schemaData = {
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        "name": $localize`:@@HOSBAY.SCHEMA_NAME_HOSBAY:Hosbay`,
        "url": "https://www.medeil.com/hosbay-healthcare",
        "description": $localize`:@@HOSBAY.SCHEMA_DESCRIPTION_HOSBAY:Discover Hosbay, the state-of-the-art hospital inventory management software designed to enhance efficiency and accuracy in healthcare operations. Streamline your supply chain, reduce waste, and improve patient care with our comprehensive solution.`,
        "applicationCategory": "BusinessApplication",
        "operatingSystem": "Cloud-based (Web, Windows, macOS, Linux)",
        "image": "https://www.medeil.com/assets/hosbay.jpg",
        "offers": {
          "@type": "Offer",
          "priceCurrency": "USD",
          "availability": "https://schema.org/InStock",
          "url": "https://www.medeil.com/hosbay-healthcare",
          "keywords": $localize`:@@HOSBAY.SCHEMA_KEYWORDS_HOSBAY:Hospital inventory management, Healthcare supply chain, Inventory tracking software, Hosbay software, Medical inventory control, Healthcare efficiency, Patient care optimization, Stock management`
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.6",
          "ratingCount": "8864"
        }
      };

      this.jsonLdService.setData(schemaData);
    }

    setFaqSchemaData() {
      const faqSchema = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": $localize`:@@FAQ.QUESTION1_HOSBAY:What challenges are you facing with your current hospital inventory system?`,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": $localize`:@@FAQ.ANSWER1_HOSBAY:We struggle with overstocking some items and running out of critical supplies like emergency medications. Manual tracking is also time-consuming.`
            }
          },
          {
            "@type": "Question",
            "name": $localize`:@@FAQ.QUESTION2_HOSBAY:Do you require real-time inventory tracking?`,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": $localize`:@@FAQ.ANSWER2_HOSBAY:Yes, real-time tracking is essential to ensure we don't run out of critical supplies during emergencies.`
            }
          },
          {
            "@type": "Question",
            "name": $localize`:@@FAQ.QUESTION3_HOSBAY:What types of assets can the system track?`,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": $localize`:@@FAQ.ANSWER3_HOSBAY:The system can track all hospital assets, including medical equipment (e.g., ventilators, ECG machines), furniture, IT equipment, and facility infrastructure like generators and HVAC systems.`
            }
          },
          {
            "@type": "Question",
            "name": $localize`:@@FAQ.QUESTION4_HOSBAY:Does the system support asset lifecycle management?`,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": $localize`:@@FAQ.ANSWER4_HOSBAY:Yes, the system tracks the entire lifecycle of an asset, from procurement to disposal, including usage history, maintenance, and depreciation.`
            }
          },
          {
            "@type": "Question",
            "name": $localize`:@@FAQ.QUESTION5_HOSBAY:Do you require barcode or QR Code scanning for inventory management?`,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": $localize`:@@FAQ.ANSWER5_HOSBAY:Yes, barcode scanning would make it easier to track items during restocking and usage.`
            }
          },
          {
            "@type": "Question",
            "name": $localize`:@@FAQ.QUESTION6_HOSBAY:What kind of reports or analytics do you need from the system?`,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": $localize`:@@FAQ.ANSWER6_HOSBAY:We need reports on stock levels, usage trends, expiration dates, and cost analysis to optimize our purchasing decisions.`
            }
          }
        ]
      };

      this.addJsonLdToHead(faqSchema);
    }




    addJsonLdToHead(schema: any) {
      const script = this.renderer.createElement('script');
      script.type = 'application/ld+json';
      script.text = JSON.stringify(schema);
      script.id = 'faq-schema';

      // Remove old schema if it exists
      const oldScript = document.getElementById('faq-schema');
      if (oldScript) {
        oldScript.remove();
      }

      this.renderer.appendChild(document.head, script);
    }
    selectclass(index: number): void {
      this.selectedclass = index;
    }
    appointment(datasource:any){
      this.enquiryForm.get('sourceRef1').setValue(datasource);
      this.ngxsmartservice.open('enquirypos');
      // this.ngxsmartservice.open('appointmentform');
    }
    closeModal(): void {
      this.ngxsmartservice.close('enquirypos');
      this.ngxsmartservice.close('appointmentform');
      this.enquiryForm.reset();
      this.enquiryForm.get('countryname1').setValue('0');
      this.generatecaptcha();
    }
    countrychange(){

      this.mainservice.getMobileCode(this.enquiryForm.get('countryname1').value).subscribe((data)=>{
        //console.log(data);
        this.dialcode=data.Dailingcode;
        console.log(this.dialcode);
       // this.registerForm.get('phonedialcode').patchValue(this.dialcode[1]);
      })
    }
    checkCaptcha(){

      var usercaptcha = this.enquiryForm.get('enteredcaptcha').value

      if (this.captcha == usercaptcha) {
        this.ecaptcha = false

      } else {

        this.errorcaptcha = 'Enter correct Captcha'
        this.ecaptcha = true
      }
    }
    generatecaptcha(){
      this.mainservice.generatecaptcha()
      this.captcha = localStorage.getItem('captcha')
    }
    submitenquery(){
      let valid=this.validation();
      if(valid){
        this.ngxsmartservice.close('enquirypos');
        this.ngxsmartservice.open('appointmentform');
        this.picker.open();
        this.inputField.focus();
      }

    }

    validation(){
      let name=this.enquiryForm.get('leadname').value
      let organizationname=this.enquiryForm.get('organizationname').value
      let primaryemail=this.enquiryForm.get('primaryemail').value
      let primaryphone=this.enquiryForm.get('primaryphone').value
      let captcha=this.enquiryForm.get('enteredcaptcha').value
      let checkbox=this.enquiryForm.get('checkbox').value

      // var usercaptcha = this.registerForm.get('enteredcaptcha').value
      if(!name){
        Swal.fire({
          position: 'center',
          icon: 'warning',
          title: 'Please Enter Name',
          showConfirmButton: false,
          timer: 1500
        })
        return false;
      }
      else if(!organizationname){
        Swal.fire({
          position: 'center',
          icon: 'warning',
          title: 'Please Enter Organization Name',
          showConfirmButton: false,
          timer: 1500
        })
        return false;
      }
      else if(!primaryemail){
        Swal.fire({
          position: 'center',
          icon: 'warning',
          title: 'Please Enter Your Email',
          showConfirmButton: false,
          timer: 1500
        })
        return false;
      }
      else if(!primaryphone){
        Swal.fire({
          position: 'center',
          icon: 'warning',
          title: 'Please Enter Your Mobile Number',
          showConfirmButton: false,
          timer: 1500
        })
        return false;
      }
      else if(!captcha){
        Swal.fire({
          position: 'center',
          icon: 'warning',
          title: 'Please Enter Captcha',
          showConfirmButton: false,
          timer: 1500
        })
        return false;
      }
      else if(captcha != this.captcha){
        Swal.fire({
          position: 'center',
          icon: 'warning',
          title: 'Please Enter Correct Captcha',
          showConfirmButton: false,
          timer: 1500
        })
        return false;
      }
      else if(checkbox==false){
        Swal.fire({
          position: 'center',
          icon: 'warning',
          title: 'Please Select Accept & Terms condition',
          showConfirmButton: false,
          timer: 1500
        })
        return false;
      }


      return true
    }
    slectdate(event: any){
      this.showElement=true;
      const selectedDate = event.value;
      const finalDate = this.datePipe.transform(selectedDate, 'yyyy-MM-dd');
      this.enquiryForm.get('appointmentdate').setValue(finalDate);
     this.currentTime = new Date();

     let map={
      "timezone":this.timezone,
      "orginaltimezone":this.currentTime
    }
    this.mainservice.gettimeSlots(map).subscribe(data=>{
      this.timeSlots = data[0].map((time:any)=> {
        const [hours, minutes] = time.split(':');
        const hours12 = ((parseInt(hours) + 11) % 12) + 1;
        const ampm = parseInt(hours) < 12 ? 'AM' : 'PM';
        return `${hours12}:${minutes} ${ampm}`;
      });
      this.showElement=false;
      console.log(this.timeSlots);
    })

      this.appointment_time=true;
    }
    selectTime(time: string): void {
      const currentTime = new Date();
      const formattedTime = this.datePipe.transform(currentTime, 'hh:mm:ss a');
      console.log(formattedTime);
      this.selectedTime = time;
      // this.enquiryForm.get('apptotime').setValue(time);
      this.enquiryForm.get('appfrmtime').setValue(time);

    }
    savelead(){
      this.showElementsave=true;



      // if (valid) {

        let phone = this.enquiryForm.get('primaryphone').value

        let mobileno=this.enquiryForm.get('phonedialcode').value+this.enquiryForm.get('primaryphone').value
        this.enquiryForm.get('primaryphone').setValue(mobileno)

         console.log('form',this.enquiryForm.value);

    this.mainservice.savelead(this.enquiryForm.value).subscribe((data: any) => {
      this.leads = data
      // console.log("this.leads",this.leads)
      if (data) {
        // this.enquiryForm.reset()
        this.showElementsave=false;
        // window.location.href= 'https://www.vanuston.com/thank-u-vanuston'
        this.enquiryForm.reset();

        // this.submitenquery();
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Data saved successfully',
          text: 'We will contact you shortly.',
          showConfirmButton: false,
          timer: 4000
        });
        this.ngxsmartservice.close('enquirypos');
        this.ngxsmartservice.close('appointmentform');
        this.enquiryForm.reset();
      }
       else{
        this.enquiryForm.get('primaryphone').setValue(phone);
        // this.showElement=false;
      }
      this.enquiryForm.get('countryname1').setValue('0');
      this.generatecaptcha();
    })

    }
    closepopup(){
      this.ngxsmartservice.close('myModal');
      this.enquiryForm.reset();

      this.enquiryForm.get('countryname1').setValue('0');
      this.generatecaptcha();
    }
    closepopup1(){
      this.ngxsmartservice.close('myModal1');
      this.enquiryForm.reset();

      this.enquiryForm.get('countryname1').setValue('0');
      this.generatecaptcha();
    }
    trynowbtn(data:any){
      // this.enquiryForm.reset();
      this.enquiryForm.get('sourceRef1').setValue(data);
      this.ngxsmartservice.open('myModal');

    }
    savesignup(){


      let valid=this.validation();

      if (valid) {
        this.showElement=true;
        let phone = this.enquiryForm.get('primaryphone').value

        let mobileno=this.enquiryForm.get('phonedialcode').value+this.enquiryForm.get('primaryphone').value
        this.enquiryForm.get('primaryphone').setValue(mobileno)

         console.log('form',this.enquiryForm.value);

    this.mainservice.savelead(this.enquiryForm.value).subscribe((data: any) => {
      this.leads = data
      // console.log("this.leads",this.leads)
      if (data) {
        // this.enquiryForm.reset()
        // window.location.href= 'https://www.vanuston.com/thank-u-vanuston'
        this.enquiryForm.reset();
        this.showElement=false;
        // this.submitenquery();
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Data saved successfully',
          text: 'We will contact you shortly.',
          showConfirmButton: false,
          timer: 4000
        });
        this.ngxsmartservice.close('myModal');
      }
       else{
        this.enquiryForm.get('primaryphone').setValue(phone);
        this.showElement=false;
      }
      this.enquiryForm.get('countryname1').setValue('0');
      this.generatecaptcha();
    })

      }
      else{
        this.showElement=false;
      }


    }
    broucher(data:any){
      this.enquiryForm.get('sourceRef1').setValue(data);
      this.ngxsmartservice.open('myModal1');
    }
    savebroucher() {
      let valid = this.validation();


      if (valid) {
        this.showElementsave = true;
        let phone = this.enquiryForm.get('primaryphone').value;
        let mobileno = this.enquiryForm.get('phonedialcode').value + this.enquiryForm.get('primaryphone').value;
        this.enquiryForm.get('primaryphone').setValue(mobileno);

        console.log('form', this.enquiryForm.value);

        this.mainservice.savelead(this.enquiryForm.value).subscribe(
          (data: any) => {

            this.leads = data;

            if (data) {
              this.enquiryForm.reset();
              this.showElementsave = false;
              Swal.fire({
                title: "Do you want to view the Brochure?",
                // showDenyButton: true,
                // showCancelButton: true,
                confirmButtonText: "yes",

              }).then((result) => {

                if (result.isConfirmed) {

              const url = 'https://medeilpos.blob.core.windows.net/websitedocuments/MEDEIL-PMSProductBrochure.pdf';
              window.open(url, '_blank');
                }
              });
              this.ngxsmartservice.close('myModal1');


            } else {
              this.enquiryForm.get('primaryphone').setValue(phone);
              this.showElement = false;
            }

            this.enquiryForm.get('countryname1').setValue('0');
            this.generatecaptcha();
          },
          (error: any) => {
            console.error('Error saving form', error);
            this.enquiryForm.get('primaryphone').setValue(phone);
            this.showElement = false;
          }
        );
      } else {
        this.showElement = false;
      }
    }
}
